import { Component, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "@src/app/ecom-services/ecom-language-service";
import { EcomSettingService } from "@src/app/ecom-services/ecom-setting.service";

@Component({
    selector: 'app-language-component',
    templateUrl: './language-dropdown.component.html',
    styleUrls: ['./language-dropdown.component.scss']
})
export class LanguageComponent {
    @Output() languageSelected = new EventEmitter<string>();

    selectedOption: string = "en";

    constructor(private languageService: LanguageService,
        private translate: TranslateService,
        private settingService: EcomSettingService) {

        this.settingService.currentUserInfo.subscribe(user => {

            this.selectedOption = user ? user.selectedLanguage: "en";

        });

    }
    selectLanguage(language: string) {
        this.languageService.selectLanguage = language;
        this.languageService.showAltLanguage = language === "zh";
        this.translate.use(language);
        this.languageSelected.emit(language);
        const user = this.settingService.getUserInfo();
        this.settingService.setUserInfo({ ...user, selectedLanguage: language });
    }

}
